import { Navigate } from "react-router-dom";

export default function ConnectPage() {
  return (
    <Navigate
      to="/auth/login"
      replace
      state={{
        message: "Use email/password for TMS login. API keys are managed in account settings for external API usage.",
      }}
    />
  );
}
